

function runCallback(callback){
    setTimeout(() => callback({added: [], _flash_messenger: {error: []}}), 555);
}

if(!window['frontAPI']){
    window['frontAPI'] = {
        addToBasket: (callback, data) => {
            runCallback(callback);
        },
        removeFromBasket: (callback, data) => {
            runCallback(callback);
        },
        getBasketInfo: (callback, data) => {
            runCallback(callback);
        },


    };
}